/**
 * Страницы образцов только с правом samples.read (E3.4c). Сервер отвечает 403 и сам, а здесь
 * у зрителя не уходит и запрос: вместо страницы — объяснение, почему образца нет. В списках, из
 * которых открываются образцы (таблицы базы, объекты кластера), то же объяснение стоит над
 * списком (SamplesNote): строка без права никуда не ведёт, и молчаливый щелчок не объясняет почему.
 */
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@/hooks/usePermissions';

export function SamplesGate({ children }: { children: ReactNode }) {
	const { t } = useTranslation('storages');
	const { has } = usePermissions();
	if (!has('samples.read')) {
		return (
			<section className="ws-section-heading" role="status">
				<div>
					<h2>{t('sampleAccess.title')}</h2>
					<p>{t('sampleAccess.hint')}</p>
				</div>
			</section>
		);
	}
	return <>{children}</>;
}

/** Пояснение над списком, строки которого ведут к образцам: у роли без samples.read */
export function SamplesNote() {
	const { t } = useTranslation('storages');
	const { has } = usePermissions();
	if (has('samples.read')) return null;
	return (
		<p className="ws-field-hint" role="note">
			{t('sampleAccess.title')}. {t('sampleAccess.hint')}
		</p>
	);
}
